import { useDispatch, useSelector } from "react-redux";

import { Button, ConfigProvider, Table, Tooltip } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import settlementApi from "../../../apis/Settlement.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

import SettlementDropdown from "./SettlementDropdown";

// import partnersApi from "../../../apis/Partners.api";
// import {setChannelUser, setUser} from "../../../redux/store/auth/authDuck";

const SettlementMonth = ({
	settlementList,
	targetYear,
	setTargetYear,
	targetMonth,
	setTargetMonth,
	getOrderList,
	orderLoading,
	serviceInfo,
}) => {
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const columns = [
		{
			title: "정산 월",
			dataIndex: "settlement_month",
			key: "settlement_month",
			render: (value) => {
				if (value) {
					return <span className={"blue"}>{moment(value).format("MM")}월</span>;
				}
			},
		},
		{
			title: "정산 완료일",
			dataIndex: "settlement_complete_date",
			key: "settlement_complete_date",
			render: (value) => {
				if (value) {
					return moment(value).format("YYYY.MM.DD");
				} else return "-";
			},
		},
		{
			title: "정산 예정일",
			dataIndex: "settlement_month",
			key: "settlement_month",
			render: (value) => {
				if (value) {
					return moment(value).add(1, "month").format("YYYY.MM.15");
				}
			},
		},
		{
			title: "구매 확정 금액",
			dataIndex: "total_purchase_amount",
			key: "total_purchase_amount",
			render: (value) => {
				if (value) {
					return value.toLocaleString();
				} else {
					return "0";
				}
			},
		},
		{
			title: "확정 수익",
			// width: 250,
			dataIndex: "profit_amount",
			key: "profit_amount",
			render: (value) => {
				if (value) {
					return value.toLocaleString();
				} else {
					return "0";
				}
			},
		},
		// {
		//     title: "부가가치세/원천세",
		//     dataIndex: 'withholding_tax',
		//     key: 'withholding_tax',
		//     render: (value, record) => {
		//         // if (record.hasOwnProperty("profit_amount") && record.profit_amount) {
		//         //     return (record.profit_amount * 0.034).toLocaleString();
		//         // }
		//         if (value) {
		//             return value.toLocaleString()
		//         } else {
		//             return "0";
		//         }
		//     }
		// },
		{
			title: "정산금액",
			dataIndex: "expected_payment_amount",
			key: "expected_payment_amount",
			render: (value) => {
				if (value) {
					return (
						<span style={{ color: "#117ffa" }}>{value.toLocaleString()}</span>
					);
				} else {
					return "0";
				}
			},
		},
		{
			title: "정산상태",
			dataIndex: "settlement_status",
			key: "settlement_status",
			render: (value, record) => {
				if (value === 1) {
					return (
						<Button
							className={`commission-button blue`}
							onClick={() => reportsSecond(record)}
						>
							{/*정산확인*/}
							정산요청
						</Button>
					);
				} else if (value === 2) {
					return (
						<Button
							className={`commission-button gray`}
							// onClick={() => reportsThird(record)}
						>
							{/*정산확정 대기중*/}
							정산요청 중
						</Button>
					);
				} else if (value === 3) {
					return (
						<Button className={`commission-button gray`} disabled={true}>
							{`확정완료`}
						</Button>
					);
				} else {
					return <p style={{ color: "#adb5bd" }}>정산예정</p>;
				}
			},
		},
	];

	const influencerColumns = [
		{
			title: "정산 월",
			dataIndex: "settlement_month",
			key: "settlement_month",
			render: (value) => {
				if (value) {
					return <span className={"blue"}>{moment(value).format("MM")}월</span>;
				}
			},
		},
		{
			title: "정산 완료일",
			dataIndex: "settlement_complete_date",
			key: "settlement_complete_date",
			render: (value) => {
				if (value) {
					return moment(value).format("YYYY.MM.DD");
				} else return "-";
			},
		},
		{
			title: "정산 예정일",
			dataIndex: "settlement_month",
			key: "settlement_month",
			render: (value) => {
				if (value) {
					return moment(value).add(1, "month").format("YYYY.MM.15");
				}
			},
		},
		{
			title: "구매 확정 금액",
			dataIndex: "total_purchase_amount",
			key: "total_purchase_amount",
			render: (value) => {
				if (value) {
					return value.toLocaleString();
				} else {
					return "0";
				}
			},
		},
		{
			title: "확정 수익",
			// width: 250,
			dataIndex: "profit_amount",
			key: "profit_amount",
			render: (value) => {
				if (value) {
					return value.toLocaleString();
				} else {
					return "0";
				}
			},
		},
		{
			title: () => {
				return (
					<>
						카톡푸시 이용 금액
						<Tooltip
							trigger={`click`}
							title={`발송 건수 X ${serviceInfo?.kakao_push_price}원`}
							overlayStyle={{ whiteSpace: "pre-wrap" }}
						>
							<img
								src={`/assets/images/report/notice.png`}
								alt={`카톡푸시 이용 금액 안내`}
								style={{
									height: "1.1em",
									width: "auto",
									cursor: "pointer",
									marginLeft: "3px",
								}}
							/>
						</Tooltip>
					</>
				);
			},
			width: 168,
			dataIndex: "kakao_push_fee",
			key: "kakao_push_fee",
			render: (value) => {
				if (value) {
					return value.toLocaleString();
				} else {
					return "0";
				}
			},
		},
		// {
		//     title: "부가가치세/원천세",
		//     dataIndex: 'withholding_tax',
		//     key: 'withholding_tax',
		//     render: (value, record) => {
		//         // if (record.hasOwnProperty("profit_amount") && record.profit_amount) {
		//         //     return (record.profit_amount * 0.034).toLocaleString();
		//         // }
		//         if (value) {
		//             return value.toLocaleString()
		//         } else {
		//             return "0";
		//         }
		//     }
		// },
		{
			title: "정산금액",
			dataIndex: "expected_payment_amount",
			key: "expected_payment_amount",
			render: (value) => {
				if (value) {
					return (
						<span style={{ color: "#117ffa" }}>{value.toLocaleString()}</span>
					);
				} else {
					return "0";
				}
			},
		},
		{
			title: "정산상태",
			dataIndex: "settlement_status",
			key: "settlement_status",
			render: (value, record) => {
				if (value === 1) {
					return (
						<Button
							className={`commission-button blue`}
							onClick={() => reportsSecond(record)}
						>
							{/*정산확인*/}
							정산요청
						</Button>
					);
				} else if (value === 2) {
					return (
						<Button
							className={`commission-button gray`}
							// onClick={() => reportsThird(record)}
						>
							{/*정산확정 대기중*/}
							정산요청 중
						</Button>
					);
				} else if (value === 3) {
					return (
						<Button className={`commission-button gray`} disabled={true}>
							{`확정완료`}
						</Button>
					);
				} else {
					return <p style={{ color: "#adb5bd" }}>정산예정</p>;
				}
			},
		},
	];

	const renderEmpty = () => (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<img
				src={`/assets/images/report/empty-data.png`}
				alt={`채널 이미지`}
				style={{ height: 70, width: 70 }}
			/>
			<span style={{ color: "rgba(0, 0, 0, 0.25)" }}>
				리포트가 비었습니다 지금부터 당영투게더와 함께하세요!
			</span>
		</div>
	);

	/**
	 * step 2) 정산확인버튼 -> 브랜드
	 * @param record
	 * @returns {Promise<void>}
	 */
	const reportsSecond = async (record) => {
		setIsLoading(true);
		try {
			Swal.fire({
				customClass: "alert-custom",
				text: `${moment(record.settlement_month).format(
					"YYYY년 M월"
				)} 내역의 정산확인을 진행하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					let param = {
						id: record.id,
						created_by: user.id,
					};
					const res = await settlementApi.postReportsSecond(param);
					if (res.code === 200) {
						alert(
							`${moment(record.settlement_month).format(
								"YYYY년 M월"
							)} 내역이 정산 확인되었습니다.`
						);
						getOrderList();
					} else {
						setIsLoading(false);
						throw res.msg;
					}
				}
			});
		} catch (e) {
			alert(e);
			setIsLoading(false);
		}
	};

	return (
		<>
			<SettlementDropdown
				targetYear={targetYear}
				setTargetYear={setTargetYear}
				targetMonth={targetMonth}
				setTargetMonth={setTargetMonth}
			/>
			<ConfigProvider renderEmpty={renderEmpty}>
				<Table
					className="report-table-wrap"
					columns={
						user?.role === "super_admin" || user?.role === "level_1"
							? influencerColumns
							: columns
					}
					dataSource={settlementList}
					loading={isLoading || orderLoading}
					rowKey="order_detail_id"
					scroll={{ x: "max-content" }}
					tableLayout="auto"
					footer={() => <></>}
					// onChange={handelTableChange}
					showSorterTooltip={false}
					pagination={false}
				/>
			</ConfigProvider>
		</>
	);
};
export default SettlementMonth;
